module.exports = __webpack_public_path__ + "media/images/official/news_image-9d52b07379b88abd92298592201a99a2.jpg";